import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import './AppointmentScheduler.scss';

import AppointmentForm from './AppointmentForm/AppointmentForm';
import CurrentState from './CurrentState/CurrentState';

import Api from '../../Shared/Helpers/Api';
import Validator from './Validator';
import Screen from '../../Shared/Helpers/Screen';
import BusyIndicator from '../../Shared/Helpers/BusyIndicator/BusyIndicator';

import { STEPS } from './constants';

export default class AppointmentScheduler extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentStep: STEPS.GENERAL_DETAILS,
            appointment: {
                date: moment().utcOffset(0, true),
                campaignId: props.campaignId
            },
            generalErrors: {},
            personalErrors: {},
            isBusy: true,
            data: {
                hours: [],
                serviceTypes: [],
                sheduleTimes: [],
                cars: [],
                appThankMessage: null,
                ShouldDisableApptForToday: false,
                ShouldDisableApptForNext24Hours: false
            }
        };

        this.moveNext = this.moveNext.bind(this);
        this.setAppointmentState = this.setAppointmentState.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
        this.moveToStep = this.moveToStep.bind(this);
    }

    componentDidMount() {
        Api.getAppointmentData().then((res) => {
            if(res.shouldDisableApptForToday || res.shouldDisableApptForNext24Hours) { 
                this.setState({
                    appointment: {
                        date: moment().utcOffset(0, true).add(1, 'days'),
                        campaignId: this.state.appointment.campaignId
                    },
                })
            }
            this.setState({
                data: res,
                isBusy: false
            });
        });
    }

    render() {
        let viewData = this.state.data;

        let view = null;

        if (this.state.isBusy) {
            view = <BusyIndicator />;
        } else {
            if (this.isFormActive) {

                view = (<AppointmentForm
                    data={this.state.data}
                    scheduleDate={this.state.appointment.date}
                    setAppointmentState={this.setAppointmentState}
                    moveNext={this.moveNext}
                    generalErrors={this.state.generalErrors}
                    personalErrors={this.state.personalErrors}
                    currentStep={this.state.currentStep}
                    appointment={this.state.appointment}
                    appointmentDetails={this.props.center.appointmentDetails}
                />);
            } else {
                if (this.state.currentStep === STEPS.THANK_YOU) {

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'appointmentSuccessful',
                    });
                    view = <ThankYouScreen center={this.props.center} thankMessage={this.state.data.appThankMessage} />;
                }
                if (this.state.currentStep === STEPS.ERROR) {
                    view = <ErrorScreen />;
                }
            }
        }

        return (
            <div className="appointment-scheduler">
                <div className="b-content">
                    <CurrentState currState={this.state.currentStep}
                        onPointClick={this.moveToStep} />
                    <h1 className="b-header">
                        SCHEDULE APPOINTMENT
                    </h1>

                    {view}
                </div>
            </div>
        );
    }

    get isFormActive() {
        return this.state.currentStep === STEPS.GENERAL_DETAILS ||
            this.state.currentStep === STEPS.PERSONAL_DETAILS
    }

    setAppointmentState(e) {
        var field = e.target.name;
        var value = e.target.value;
        this.state.appointment[field] = value;

        // for now reseting errors for both steps for current name
        // as a quick solution

        delete this.state.generalErrors[field];
        delete this.state.personalErrors[field];

        return this.setState({
            appointment: this.state.appointment,
            generalErrors: this.state.generalErrors,
            personalErrors: this.state.personalErrors
        });
    }

    isGeneralValid() {
        let isValid = false;
        this.state.generalErrors = {};
        let form = this.state.appointment;

        //if (!form.center) {
        //    this.state.generalErrors['center'] = 'Please choose a center!';
        //}

        if (!form.hours) {
            this.state.generalErrors['hours'] = 'Please choose available hours';
        }

        if (!form.serviceType) {
            this.state.generalErrors['serviceType'] = 'Please choose service type';
        }

        if (!form.make) {
            this.state.generalErrors['make'] = 'Please choose car make';
        }

        //if (!form.carModel) {
        //    this.state.generalErrors['carModel'] = 'Please choose car model';
        //}

        if (!Validator.carYear(form.CarYear)) {
            this.state.generalErrors['carYear'] = 'Please specify valid car year';
        }
       

        this.setState({
            generalErrors: this.state.generalErrors
        });

        if (!Object.keys(this.state.generalErrors).length) {
            isValid = true;
        }

        return isValid;
    }

    moveNext() {
        if (this.state.currentStep === STEPS.GENERAL_DETAILS &&
            this.isGeneralValid()) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'completedStepOne'
            }); 
            this.setState({
                currentStep: STEPS.PERSONAL_DETAILS
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'completedStepOne'
            }); 
        } else if (this.state.currentStep === STEPS.PERSONAL_DETAILS) {
            this.submitRequest();
        }
    }

    moveToStep(stepId) {
        this.setState({
            currentStep: stepId
        });
    }

    isPersonalValid() {
        let isValid = false;
        this.state.personalErrors = {};
        let appointment = this.state.appointment;

        if (!Validator.name(appointment.name)) {
            this.state.personalErrors['name'] = 'Please enter a valid name!';
        }

        if (!Validator.email(appointment.email)) {
            this.state.personalErrors['email'] = 'Please enter a valid email!';
        }

        if (!Validator.phone(appointment.phone)) {
            this.state.personalErrors['phone'] = 'Please enter a valid phone number!';
        }

        if (!Validator.comments(appointment.comment)) {
            this.state.personalErrors['comment'] = 'Comment exceeded max length';
        }
        if (!(appointment.captcha && appointment.captcha.getValue())) {
            this.state.personalErrors['captcha'] = 'Please check the captcha';
        }

        this.setState({
            personalErrors: this.state.personalErrors
        });

        if (!Object.keys(this.state.personalErrors).length) isValid = true;

        return isValid;
    }

    submitRequest() {
        if (this.isPersonalValid()) {
            this.setState({
                isBusy: true
            });
            
            this.state.appointment.captcha = undefined;
         
            let response = Api.submitAppointment(this.state.appointment)
                .then((res) => {
                    let nextStep = res.ok ? STEPS.THANK_YOU : STEPS.ERROR;

                    this.setState({
                        currentStep: nextStep,
                        isBusy: false
                    });
                });
        }
    }
}

function ThankYouScreen(props) {
    return (<div className="thank-you-wrapper centered-section">
        <img className="main-icon" src="/images/appointment/icon-success.svg" />
        <h3 className="step-title">
            Thank you
        </h3>
        <h4 className="subtitle">
            Your request has been sent successfully.
        </h4>


        {
            props.thankMessage !== null &&
            <small className="disclaimer" dangerouslySetInnerHTML={{ __html: props.thankMessage }} />
        }
        {
            props.thankMessage == null &&
            <small className="disclaimer">


                Please allow up to 24hr to receive your confirmation*.
        <br />
                If this is an emergency please contact our center by phone {" "}
                <a href={`tel:${props.center.phoneNumber}`}>
                    {props.center.phoneNumber}
                </a>

            </small>
        }

      

        <HomeBtn />
    </div>);
}

function ErrorScreen(props) {
    return (<div className="error-wrapper centered-section">
        <h3 className="step-title error">
            Error
            </h3>
        Please contact support
            <HomeBtn />
    </div>);
}

function HomeBtn(props) {
    return (
        <a className="apply-btn"
            href="/" >
            Back to Home
        </a>);
}

export let SchedulerInstance = null;

// used for direct component access from outside
let refCallback = (ref) => {
    SchedulerInstance = ref;
}

//ReactDOM.render(<AppointmentScheduler ref={refCallback} />, document.getElementById('appointment-wrap'));

ReactDOM.render(<AppointmentScheduler ref={refCallback} campaignId={document.getElementById('appointment-wrap').getAttribute("campaignId")} />, document.getElementById('appointment-wrap'));




// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/AppointmentScheduler.jsx